import {useMap} from "@vis.gl/react-google-maps";
import {useEffect, useRef} from "react";
import {MarkerClusterer} from "@googlemaps/markerclusterer";
import dedupeByLatLng from "../utils/dedupeByLatLng.js";

export function MarkerCluster({ markersData, selectedMarkerId, onMarkerClick}) {
    const map = useMap();
    const clustererRef = useRef(null);
    const markersRef = useRef([]);

    useEffect(() => {
        if (!map || !markersData?.size || !google?.maps?.marker) return;

        function resolveGroupZIndex(markers) {
            return Math.max(...markers.map(m => m.zIndex ?? 0));
        }

        const uniqueMarkers = dedupeByLatLng(markersData);
        clustererRef.current?.clearMarkers();
        markersRef.current.forEach(m => (m.map = null));
        markersRef.current = [];

        const markers = [];
        const { AdvancedMarkerElement, PinElement } = google.maps.marker;

        uniqueMarkers.forEach(marker => {
            const isSelected = marker.markers.some(
                passage => passage.id === selectedMarkerId
            );

            const pin = new PinElement({
                background: marker.color,
                borderColor: "#333333",
                glyphText: marker.glyphText ?? "",
                glyphColor: "#000000",
            });

            if (isSelected) {
                pin.element.classList.add("animate-bounce");
            } else {
                pin.element.classList.remove("animate-bounce");
            }

            const advMarker = new AdvancedMarkerElement({
                position: { lat: marker.lat, lng: marker.lng },
                content: pin.element,
                zIndex: marker.zIndex
            });

            advMarker.addListener("click", () => {
                onMarkerClick(marker.lat, marker.lng);
            });

            markers.push(advMarker);
            markersRef.current.push(advMarker);
        });

        clustererRef.current = new MarkerClusterer({
            map,
            markers,
            renderer: {
                render({ count, position }) {
                    return new google.maps.Marker({
                        position,
                        icon: {
                            path: google.maps.SymbolPath.CIRCLE,
                            scale: 18,
                            fillColor: "#2563eb",
                            fillOpacity: 0.95,
                            strokeWeight: 0,
                        },
                        label: {
                            text: String(count),
                            color: "#ffffff",
                            fontSize: "14px",
                            fontWeight: "bold",
                        },
                        zIndex: 1000 + count,
                    });
                },
            },
        });


        return () => {
            clustererRef.current?.clearMarkers();
            markersRef.current.forEach(m => (m.map = null));
        };
    }, [map, markersData, selectedMarkerId]);

    return null;
}